<template>
  <div class="product">
    <div class="container">
      <div>
        <Title />
        <div class="row justify-content-between">
          <Breadcrumb />
          <div class="col-12 col-sm text-end mb-3 mb-sm-0">
            <button
              type="button"
              class="btn btn-transparent"
              @click="showModal(null)"
            >
              新增產品
            </button>
          </div>
        </div>
      </div>
      <div class="card mb-3 table-top-bar">
        <div class="card-body p-0">
          <div class="input-group">
            <span class="input-group-text d-none d-sm-block">
              顯示第
              {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
              {{
                currentPage == 1
                  ? totalRows > perPage
                    ? perPage
                    : totalRows
                  : perPage * (currentPage - 1) + perPage > totalRows
                  ? totalRows
                  : perPage * (currentPage - 1) + perPage
              }}
              項結果，共 {{ totalRows }} 項
            </span>
            <input
              v-model="filter"
              type="text"
              class="form-control"
              placeholder="搜尋"
            />
            <span class="input-group-text"><i class="bi bi-search"></i></span>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-body">
          <b-table
            :responsive="windowWidth > breakpoints.sm"
            :stacked="windowWidth <= breakpoints.sm"
            borderless
            no-provider-filtering
            head-variant="light"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template v-slot:head()="scope">
              <div class="text-nowrap">
                {{ scope.label }}
              </div>
            </template>
            <template v-slot:cell(image)="data">
              <div class="imgBox" style="width: 100px">
                <div class="imgBox-inner">
                  <div class="imgBox-fit">
                    <img
                      v-if="data.item.image[0].link"
                      :src="data.item.image[0].link"
                      alt=""
                    />
                    <i v-else class="bi bi-image"></i>
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:cell(category)="data">
              {{ data.item.category.name }}
            </template>
            <template v-slot:cell(active)="data">
              <div class="d-flex flex-nowrap flex align-items-center">
                <div class="form-check check-icon">
                  <input
                    v-model="data.item.show"
                    class="form-check-input"
                    type="checkbox"
                    :id="'state' + data.item.id"
                    @click="toggleProductShow(data.item.id)"
                  />
                  <label
                    class="form-check-label"
                    :class="{ 'text-primary': data.item.show }"
                    :for="'state' + data.item.id"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="data.item.show ? '隱藏' : '顯示'"
                  >
                    <i
                      class="bi"
                      :class="
                        data.item.show ? ' bi-eye-fill' : 'bi-eye-slash-fill'
                      "
                    ></i>
                  </label>
                </div>
                <button
                  @click="showModal(data.item.id)"
                  type="button"
                  class="btn btn-link px-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="編輯"
                >
                  <i class="bi bi-pencil mx-1 fs-5"></i>
                </button>
                <button
                  @click="showDeleteModal(data.item.id, data.item.name)"
                  type="button"
                  class="btn btn-link px-1 text-danger"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="移除"
                >
                  <i class="bi bi-trash me-2"></i>
                </button>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="d-block d-sm-none text-center mb-3">
        顯示第 {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
        {{
          currentPage == 1
            ? totalRows > perPage
              ? perPage
              : totalRows
            : perPage * (currentPage - 1) + perPage > totalRows
            ? totalRows
            : perPage * (currentPage - 1) + perPage
        }}
        項結果，共 {{ totalRows }} 項
      </div>
      <b-pagination
        v-if="totalRows > perPage"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="right"
        first-number
        last-number
        class="mb-sm-0 mb-3 mt-sm-0 mt-3"
      ></b-pagination>
    </div>
    <div
      class="modal fade"
      id="productModal"
      tabindex="-1"
      ref="productModal"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-lg modal-fullscreen-lg-down modal-dialog-scrollable"
      >
        <div class="modal-content" v-if="modalDate">
          <div class="modal-header">
            <h5 class="modal-title">{{ isEdit ? '編輯產品' : '新增產品' }}</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="save">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-check mb-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="modalDate.show"
                      id="modalShow"
                    />
                    <label class="form-check-label" for="modalShow">
                      上架
                    </label>
                  </div>
                  <div class="mb-3">
                    <label for="modalName" class="form-label required"
                      >名稱</label
                    >
                    <input
                      v-model="modalDate.name"
                      type="text"
                      class="form-control"
                      id="modalName"
                      placeholder="請輸入"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label for="modalSerialNo" class="form-label required"
                      >編號</label
                    >
                    <input
                      v-model="modalDate.serial_no"
                      type="text"
                      class="form-control"
                      id="modalSerialNo"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <label class="form-label required">分類</label>
                    <select
                      v-model="modalDate.category_id"
                      class="form-select"
                      required
                    >
                      <option :value="null">請選擇分類</option>
                      <option
                        v-for="category in productCategory"
                        :value="category.id"
                        :key="'productCategory' + category.id"
                      >
                        {{ category.name }}
                      </option>
                    </select>
                  </div>
                  <div
                    class="mb-3"
                    v-if="productCategorySub && productCategorySub.length"
                  >
                    <label class="form-label required">子分類</label>
                    <select
                      v-model="modalDateCategorySub"
                      class="form-select"
                      required
                    >
                      <option :value="null">請選擇子分類</option>
                      <option
                        v-for="category in productCategorySub"
                        :value="category.id"
                        :key="'productCategory' + category.id"
                      >
                        {{ category.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="websiteKeyword" class="form-label"
                      >關鍵字</label
                    >
                    <div class="form-text mb-3">
                      用 於 SEO Keyword，最多添加 5 項。
                    </div>
                    <div>
                      <button
                        type="button"
                        @click="modalDate.seo_keyword.splice(index, 1)"
                        class="btn btn-primary rounded-pill me-2 mb-2 pe-3"
                        v-for="(keywords, index) in modalDate.seo_keyword"
                        :key="keywords + index"
                      >
                        {{ keywords }} <i class="bi bi-x ps-2"></i>
                      </button>
                    </div>
                    <button
                      type="button"
                      @click="showKeywordsModal"
                      v-show="
                        modalDate.seo_keyword &&
                        modalDate.seo_keyword.length < 5
                      "
                      class="btn btn-outline-primary mt-2"
                      :class="{ 'is-invalid': invalid.keywords }"
                    >
                      <i class="bi bi-plus"></i> 新增關鍵字...
                    </button>
                    <div class="invalid-feedback" v-show="invalid.keywords">
                      {{ invalid.keywords }}
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="websiteDescription" class="form-label"
                      >產品簡介</label
                    >
                    <textarea
                      v-model="modalDate.seo_introduce"
                      class="form-control"
                      id="websiteDescription"
                      rows="3"
                      placeholder="請輸入"
                    ></textarea>
                    <div class="form-text">
                      {{
                        modalDate.seo_introduce
                          ? modalDate.seo_introduce.length
                          : 0
                      }}
                      / 160
                    </div>
                    <div class="form-text">
                      用於 SEO Description，建議中文字數控制在 80
                      字以內，英文字數控制在 160 字以內。
                    </div>
                  </div>
                </div>
              </div>
              <div class="my-3">
                <div class="d-flex justify-content-between">
                  <div>
                    <label class="form-label required">圖片</label>
                    <span class="form-text"
                      >(最多 10 張圖片，第 1 張為主圖)</span
                    >
                  </div>
                  <button
                    v-if="
                      modalDate &&
                      modalDate.image &&
                      modalDate.image.length < 10
                    "
                    type="button"
                    class="btn btn-outline-primary mb-3"
                    @click="addImage"
                  >
                    新增圖片
                  </button>
                </div>
                <div class="table-responsive">
                  <table class="table align-middle text-nowrap border">
                    <thead>
                      <tr>
                        <th scope="col" class="text-center" style="width: 54px">
                          排序
                        </th>
                        <th scope="col" style="width: 220px">
                          產品圖片(格式：JPG、PNG)
                        </th>
                        <th scope="col" style="width: 283px">
                          圖片說明(用於SEO圖片搜尋)
                        </th>
                        <th scope="col" style="width: 60px">移除</th>
                      </tr>
                    </thead>
                    <draggable
                      tag="tbody"
                      v-model="modalDate.image"
                      handle=".drag"
                      animation="1000"
                    >
                      <tr
                        v-for="(table, index) in modalDate.image"
                        :key="'slideshow' + index"
                      >
                        <td class="drag text-center" style="cursor: all-scroll">
                          <i class="bi bi-arrows-move"></i>
                        </td>
                        <td class="text-center">
                          <label
                            :for="'imagePcFile' + index"
                            class="imgBox"
                            style="width: 200px; cursor: pointer"
                          >
                            <div class="imgBox-inner">
                              <div class="imgBox-fit" style="padding-top: 46%">
                                <img
                                  v-if="table.link"
                                  :src="table.link"
                                  alt=""
                                />
                                <i v-else class="bi bi-image"></i>
                              </div>
                            </div>
                          </label>
                          <input
                            class="form-control d-none"
                            type="file"
                            :id="'imagePcFile' + index"
                            accept="image/png, image/jpeg"
                            @change="onFileChange($event.target, index)"
                          />
                        </td>
                        <td>
                          <input
                            v-model="table.desc"
                            type="text"
                            class="form-control"
                          />
                        </td>
                        <td>
                          <button
                            type="button"
                            class="btn btn-close p-2"
                            @click="deleteImage(index)"
                          ></button>
                        </td>
                      </tr>
                    </draggable>
                  </table>
                </div>
              </div>
              <div class="my-3">
                <div class="d-flex justify-content-between">
                  <label class="form-label required">款式列表</label>
                  <button
                    v-if="
                      modalDate &&
                      modalDate.specification &&
                      modalDate.specification.length < 10
                    "
                    type="button"
                    class="btn btn-outline-primary mb-3"
                    @click="addSpecification"
                  >
                    新增款式
                  </button>
                </div>
                <div class="table-responsive">
                  <table class="table align-middle text-nowrap border">
                    <thead>
                      <tr>
                        <th scope="col" class="text-center" style="width: 54px">
                          排序
                        </th>
                        <th scope="col" style="width: 220px">款式名稱</th>
                        <th scope="col" style="width: 283px">款式金額</th>
                        <th scope="col" style="width: 60px">移除</th>
                      </tr>
                    </thead>
                    <draggable
                      tag="tbody"
                      v-model="modalDate.specification"
                      handle=".drag"
                      animation="1000"
                    >
                      <tr
                        v-for="(table, index) in modalDate.specification"
                        :key="'slideshow' + index"
                      >
                        <td class="drag text-center" style="cursor: all-scroll">
                          <i class="bi bi-arrows-move"></i>
                        </td>
                        <td class="text-center">
                          <input
                            v-model="table.name"
                            type="text"
                            class="form-control"
                            required
                          />
                        </td>
                        <td>
                          <input
                            v-model="table.price"
                            type="number"
                            class="form-control"
                            required
                          />
                        </td>
                        <td>
                          <button
                            type="button"
                            class="btn btn-close p-2"
                            @click="deleteSpecification(index)"
                          ></button>
                        </td>
                      </tr>
                    </draggable>
                  </table>
                </div>
              </div>
              <div class="my-3">
                <label class="form-label">產品介紹</label>
                <quill v-model="modalDate.introduce" />
              </div>
              <div class="my-3">
                <label class="form-label">詳細規格</label>
                <quill v-model="modalDate.detail" />
              </div>
              <div class="my-3">
                <label class="form-label">品牌介紹</label>
                <quill v-model="modalDate.brand" />
              </div>
              <button ref="submit" type="submit" class="d-none"></button>
            </form>
          </div>
          <div class="modal-footer">
            <div
              class="alert alert-danger w-100 mb-2 py-2"
              role="alert"
              v-if="invalid.image || invalid.specification"
            >
              {{ invalid.image || invalid.specification }}
            </div>
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button
              @click="$refs.submit.click()"
              type="button"
              class="btn btn-primary"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
    <KeywordsModal
      @setKeywords="addKeywords"
      :keywords="modalDate.seo_keyword"
    />
    <DeleteModal
      name="產品"
      :deleteItem="deleteItem"
      @confirmDelete="deleteProduct"
    />
  </div>
</template>

<script>
import { product } from '@/http/api/product.js'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import quill from '@/components/plugin/Quill.vue'
import { Modal } from 'bootstrap'
import Title from '@/components/layout/Title.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'
import DeleteModal from '@/components/modal/DeleteModal.vue'
import KeywordsModal from '@/components/modal/KeywordsModal.vue'

const defaultModalDate = {
  brand: null,
  category_id: null,
  detail: null,
  image: [],
  introduce: null,
  name: null,
  serial_no: null,
  seo_keyword: [],
  specification: [],
  show: true
}
const defaultInvalidDate = {
  image: null,
  specification: null,
  modalKeywords: null,
  keywords: null
}

export default {
  name: 'Product',
  components: {
    quill,
    Title,
    draggable,
    Breadcrumb,
    DeleteModal,
    KeywordsModal
  },
  data () {
    return {
      bootstrap_modal: null,
      currentPage: 1,
      deleteItem: '',
      errMsg: null,
      errMsgKey: {
        category_id: '分類',
        serial_no: '編號',
        name: '名稱',
        seo_keyword: '關鍵字',
        image: '圖片',
        specification: '款式',
        introduce: '產品介紹',
        detail: '詳細規格',
        brand: '品牌介紹',
        show: '上架狀態'
      },
      filter: null,
      filterOn: ['name', 'serial_no', 'category'],
      fields: [
        {
          key: 'serial_no',
          label: '編號',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'image',
          label: '圖片',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'name',
          label: '名稱',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'category',
          label: '分類',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'active',
          label: '功能',
          class: 'align-middle'
        }
      ],
      items: null,
      isEdit: false,
      invalid: JSON.parse(JSON.stringify(defaultInvalidDate)),
      invalidTimeout: null,
      modalID: null,
      modalDate: JSON.parse(JSON.stringify(defaultModalDate)),
      modalDateCategorySub: null,
      productCategory: null,
      productCategorySub: null
    }
  },
  computed: {
    ...mapState([
      'token',
      'windowWidth',
      'breakpoints',
      'perPage',
      'totalRows',
      'isShowKeywordsModal'
    ]),
    ...mapGetters(['errMsgInfo'])
  },
  watch: {
    'token.headers.Authorization': function (data) {
      if (data) {
        this.initialEvent()
      }
    },
    currentPage () {
      this.$nextTick(() => this.InitBootstrapTooltip())
    },
    items () {
      this.$nextTick(() => this.InitBootstrapTooltip())
    },
    isShowKeywordsModal (data) {
      if (!data) this.bootstrap_modal.show()
    },
    'modalDate.category_id': function (data) {
      this.modalDateCategorySub = null
      if (data) {
        this.getProductCategorySub(data)
      }
    },
    invalid: {
      handler (data) {
        const vm = this
        if (vm.invalidTimeout) {
          clearTimeout(vm.invalidTimeout)
          vm.invalidTimeout = null
        }
        vm.invalidTimeout = setTimeout(() => {
          vm.invalid = JSON.parse(JSON.stringify(defaultInvalidDate))
        }, 5000)
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations([
      'AlertsInfo',
      'Alerted',
      'InitBootstrapTooltip',
      'Loading',
      'Loaded',
      'SetRouterName',
      'SetTotalRows',
      'SetErrMsg',
      'SetErrMsgKey',
      'ToggleDeleteModal',
      'ToggleKeywordsModal'
    ]),
    ...mapActions(['uploadImage']),
    addKeywords (data) {
      const vm = this
      vm.modalDate.seo_keyword = data
    },
    addImage () {
      this.modalDate.image.push({ link: '', desc: '' })
    },
    addSpecification () {
      this.modalDate.specification.push({ name: '', price: '' })
    },
    createProduct () {
      const vm = this
      product
        .create(vm.modalDate, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '創建資料成功'
            })
            vm.bootstrap_modal.hide()
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    deleteProduct () {
      const vm = this
      vm.Loading()
      product
        .delete(vm.modalID, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '刪除資料成功'
            })
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.ToggleDeleteModal(false)
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    deleteImage (index) {
      const vm = this
      vm.modalDate.image.splice(index, 1)
    },
    deleteSpecification (index) {
      const vm = this
      vm.modalDate.specification.splice(index, 1)
    },
    getData () {
      const vm = this
      vm.Loading()
      product
        .get('', vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.items = data.data.sort((a, b) =>
              Date.parse(a.created_at).valueOf() >
              Date.parse(b.created_at).valueOf()
                ? -1
                : 1
            )
            vm.SetTotalRows(vm.items.length)
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    getProductCategory () {
      const vm = this
      product
        .getCategory('', vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.productCategory = data.data.filter(
              (category) => category.parent_id === 0
            )
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
        })
    },
    getProductCategorySub (id) {
      const vm = this
      const config = { ...vm.token }
      config.params = {
        parent_id: id
      }
      product
        .getCategory('', config)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.productCategorySub = data.data
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    initialEvent () {
      const vm = this
      vm.getData()
      vm.getProductCategory()
    },
    invalidMessage () {
      const vm = this
      const isNullImageLink = (image) => !image.link

      if (!vm.modalDate.image.length) {
        vm.invalid.image = '圖片最少上傳一張'
        return true
      }

      if (vm.modalDate.image.every(isNullImageLink)) {
        vm.invalid.image = '圖片不可留空'
        return true
      }

      if (!vm.modalDate.specification.length) {
        vm.invalid.specification = '款式最少設定一項'
        return true
      }
    },
    onFiltered (filteredItems) {
      const vm = this
      vm.SetTotalRows(filteredItems.length)
      vm.currentPage = 1
    },
    onFileChange (event, index) {
      const vm = this
      vm.uploadImage(event).then((value) => {
        if (value) {
          vm.modalDate.image[index].link = value
        }
      })
    },
    save () {
      const vm = this
      if (vm.invalidMessage()) return
      if (vm.modalDateCategorySub) {
        vm.modalDate.category_id = vm.modalDateCategorySub
      }
      vm.Loading()
      if (vm.isEdit) {
        vm.updateProduct()
        return
      }
      vm.createProduct()
    },
    showModal (id) {
      const vm = this
      vm.modalID = id
      vm.bootstrap_modal = new Modal(vm.$refs.productModal, {
        backdrop: 'static',
        keyboard: false
      })
      vm.isEdit = false
      if (!id) {
        vm.modalDate = vm.modalDate = JSON.parse(
          JSON.stringify(defaultModalDate)
        )
        vm.bootstrap_modal.show()
        return
      }
      vm.isEdit = true
      vm.Loading()
      product
        .get(id, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.modalDate = data.data
            if (vm.modalDate.category.parent_id) {
              vm.modalDate.category_id = vm.modalDate.category.parent_id
              setTimeout(() => {
                vm.modalDateCategorySub = data.data.category.id
              }, 0)
            }
            vm.bootstrap_modal.show()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    showKeywordsModal () {
      const vm = this
      vm.ToggleKeywordsModal(true)
      vm.bootstrap_modal.hide()
    },
    showDeleteModal (id, title) {
      const vm = this
      vm.modalID = id
      vm.deleteItem = title
      vm.ToggleDeleteModal(true)
    },
    toggleProductShow (id) {
      const vm = this
      vm.Loading()
      product.get(id, vm.token).then((res) => {
        const { data } = res
        if (res.status <= 201 && data.status === 'success') {
          const productDate = data.data
          productDate.show = productDate.show ? 0 : 1
          product
            .update(id, productDate, vm.token)
            .then((res) => {
              if (res.status <= 201 && data.status === 'success') {
                vm.AlertsInfo({
                  state: 'success',
                  title: '成功',
                  info: '變更顯示狀態成功'
                })
                vm.getData()
              } else {
                vm.SetErrMsg(data.errMsg)
                vm.AlertsInfo({
                  state: 'error',
                  title: '失敗 ' + res.status,
                  info: vm.errMsgInfo
                })
              }
              vm.Alerted()
              vm.Loaded()
            })
            .catch((err) => {
              vm.SetErrMsg(err)
              vm.AlertsInfo({
                state: 'error',
                title: '失敗',
                info: vm.errMsgInfo
              })
              vm.Alerted()
              vm.Loaded()
            })
        }
      })
    },
    updateProduct () {
      const vm = this
      product
        .update(vm.modalID, vm.modalDate, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '更新資料成功'
            })
            vm.bootstrap_modal.hide()
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    }
  },
  created () {
    const vm = this
    vm.SetRouterName(vm.$route.name)
    vm.SetErrMsgKey(vm.errMsgKey)
  },
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.initialEvent()
    }
  }
}
</script>
